module.exports = __webpack_public_path__ + "static/media/hidden.f6bdf0a0.svg";